import { render, staticRenderFns } from "./CasamentoEHabilitacoes.vue?vue&type=template&id=25039e33&"
import script from "./CasamentoEHabilitacoes.vue?vue&type=script&lang=js&"
export * from "./CasamentoEHabilitacoes.vue?vue&type=script&lang=js&"
import style0 from "./CasamentoEHabilitacoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports